import {
  FacebookIcon,
  InstagramIcon,
  LinkedIcon,
  TwitterIcon,
} from 'components/Common/Icon'
import Image from 'next/image'
import Link from 'next/link'
import { Col, Container, Row } from 'react-bootstrap'
// import imageLogoCZ from '../../../../public/assets/images/codezeros_logo.svg'
// import imageLogoDataEximit from '../../../../public/assets/images/data-examit.svg'
// import imageLogoSlangbusters from '../../../../public/assets/images/slangbusters_logo.svg'

// import iconFacebook from '../../../../public/assets/images/facebook-icon.png'
// import iconInsta from '../../../../public/assets/images/insta-icon.png'
// import iconLinkedin from '../../../../public/assets/images/linkedin-icon.png'
// import iconTwitter from '../../../../public/assets/images/twitter-icon-new.png'

// import iconLogoFooter from '../../../../public/assets/images/logo.svg'

const imageLogoCZ = '/assets/images/codezeros_logo.svg'
const imageLogoDataEximit = '/assets/images/data-examit.svg'
const imageLogoSlangbusters = '/assets/images/slangbusters_logo.svg'

const iconLogoFooter = '/assets/images/logo.svg'

// eslint-disable-next-line no-var, @typescript-eslint/no-explicit-any

function Footer() {
  return (
    <footer data-aos="fade-in">
      <Container>
        <Row>
          <Col lg={12} className="d-flex justify-content-center">
            <div className="our_companies d-flex align-items-center">
              <div className="left_title">Our Companies</div>
              <div className="d-flex align-items-center">
                <div className="oc_item">
                  <Link
                    href="https://www.codezeros.com/"
                    className="text-decoration-none"
                    target="_blank"
                  >
                    <Image
                      src={imageLogoCZ}
                      className="mx-auto"
                      alt="codezeros"
                      width={172}
                      height={22}
                      style={{
                        maxWidth: '100%',
                        height: 'auto',
                      }}
                    />
                  </Link>
                </div>
                <div className="oc_item">
                  <Link
                    href="https://www.slangbusters.com/"
                    className="text-decoration-none"
                    target="_blank"
                  >
                    <Image
                      src={imageLogoSlangbusters}
                      className="mx-auto"
                      alt="slangbusters"
                      width={166}
                      height={40}
                      style={{
                        maxWidth: '100%',
                        height: 'auto',
                      }}
                    />
                  </Link>
                </div>
                <div className="oc_item bdr_none">
                  <Link
                    href="https://www.dataeximit.com/"
                    className="text-decoration-none"
                    target="_blank"
                  >
                    <Image
                      src={imageLogoDataEximit}
                      className="mx-auto"
                      alt="dataeximit"
                      width={132}
                      height={28}
                      style={{
                        maxWidth: '100%',
                        height: 'auto',
                      }}
                    />
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <div className="footer_inner">
        <Container>
          <Row>
            <Col lg={4}>
              <div className="footer_logo mb-4">
                <Link href="/">
                  <Image
                    src={iconLogoFooter}
                    alt="logo-footer"
                    width={250}
                    height={68}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </Link>
              </div>
              <div className="text_para about_text pe-lg-5 me-lg-5">
                WebClues Infotech is a CMMI Level 5 certified company. We are a
                globally recognized Web and Mobile App Solution provider with
                offices in INDIA, the USA, & UAE. We help you to define your
                business processes and accelerate growth by offering future-gen
                digital solutions.
              </div>
              <ul className="social d-flex pb-3 pb-lg-0 mt-4 pt-2">
                <li className="me-4">
                  <Link
                    href="https://www.linkedin.com/company/webclues-infotech"
                    target="_blank"
                    className="text-text-decoration-none"
                  >
                    <LinkedIcon />
                  </Link>
                </li>
                <li className="me-4">
                  <Link
                    href="https://www.facebook.com/WebCluesInfotechLLP/"
                    target="_blank"
                    className="text-text-decoration-none"
                  >
                    <FacebookIcon />
                  </Link>
                </li>
                <li className="me-4">
                  <Link
                    href="https://www.instagram.com/webcluesinfotech/"
                    target="_blank"
                    className="text-text-decoration-none"
                  >
                    <InstagramIcon />
                  </Link>
                </li>
                <li className="me-4">
                  <Link
                    href="https://twitter.com/Webcluesinfo"
                    target="_blank"
                    className="text-text-decoration-none"
                  >
                    <TwitterIcon />
                  </Link>
                </li>
                {/* <li className="me-3">
                  <Link href="https://www.behance.net/webcluesin486f/">
                    <a target="_blank" className="text-text-decoration-none">
                      <Image
                        src={iconBehance}
                        alt="behance-icon"
                        width={30}
                        height={30}
                      />
                    </a>
                  </Link>
                </li> */}
              </ul>
            </Col>
            <Col lg={8}>
              <Row>
                <Col sm={6} md={4}>
                  <h3 className="footer_title">Expertise</h3>
                  <ul className="footerlinks pb-2 pb-lg-0">
                    <li>
                      <Link
                        href="/hire-dedicated-developers"
                        className="footer_link"
                      >
                        Team Extension
                      </Link>
                    </li>
                    <li>
                      <Link
                        href="/product-engineering-services"
                        className="footer_link"
                      >
                        Product Engineering
                      </Link>
                    </li>
                    <li>
                      <Link
                        href="/web-development-services"
                        className="footer_link"
                      >
                        Web Development
                      </Link>
                    </li>
                    <li>
                      <Link
                        href="/mobile-app-development-services"
                        className="footer_link"
                      >
                        Mobility
                      </Link>
                    </li>
                    <li>
                      <Link
                        href="/cloud-devops-services"
                        className="footer_link"
                      >
                        Cloud and DevOps
                      </Link>
                    </li>
                    <li>
                      <Link
                        href="/quality-assurance-services"
                        className="footer_link"
                      >
                        QA Service
                      </Link>
                    </li>
                    <li>
                      <Link
                        href="/ui-ux-design-services"
                        className="footer_link"
                      >
                        UI/UX Design
                      </Link>
                    </li>
                  </ul>
                </Col>
                <Col sm={6} md={4}>
                  <h3 className="footer_title">Quick Links</h3>
                  <ul className="footerlinks pb-2 pb-lg-0">
                    <li>
                      <Link href="/about-us" className="footer_link">
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link href="/it-solutions" className="footer_link">
                        Services
                      </Link>
                    </li>
                    <li>
                      <Link href="/technology" className="footer_link">
                        Technology
                      </Link>
                    </li>
                    <li>
                      <Link href="/portfolio" className="footer_link">
                        Work
                      </Link>
                    </li>
                    <li>
                      <Link href="/join-our-team" className="footer_link">
                        Careers
                      </Link>
                    </li>
                    <li>
                      <Link href="/blog" className="footer_link">
                        Blog
                      </Link>
                    </li>
                    <li>
                      <Link href="/contact-us" className="footer_link">
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </Col>
                <Col md={4}>
                  <h3 className="footer_title">Contact Us</h3>
                  <ul className="footerlinks pb-2 pb-lg-0">
                    <li>
                      For Sales:&nbsp;
                      <Link href="tel:+918141068282" className="footer_link">
                        +91-814-106-8282
                      </Link>
                    </li>
                    <li>
                      USA&nbsp;
                      <Link href="tel:+19783099910" className="footer_link">
                        +1-(978)-309-9910
                      </Link>
                    </li>
                    <li>
                      UAE&nbsp;
                      <Link href="tel:+971502578857" className="footer_link">
                        +971-50-257-8857
                      </Link>
                    </li>
                    <li>
                      UK&nbsp;
                      <Link href="tel:+447768418141" className="footer_link">
                        +44-776-841-8141
                      </Link>
                    </li>
                    <li>
                      AUS&nbsp;
                      <Link href="tel:+61480193028" className="footer_link">
                        +61-480-193-028
                      </Link>
                    </li>
                    <li>
                      Canada&nbsp;
                      <Link href="tel:+16479497499" className="footer_link">
                        +1-647-949-7499
                      </Link>
                    </li>

                    <li className="mt-4">
                      For Jobs:&nbsp;
                      <Link href="tel:+919512182820" className="footer_link">
                        +91-951-218-2820
                      </Link>
                    </li>
                  </ul>
                  <h3 className="footer_title mt-4 pt-1">
                    Have Any Questions?
                  </h3>
                  <ul className="footerlinks pb-2 pb-lg-0">
                    <li>
                      <Image
                        src="/assets/images/mail-small.svg"
                        alt="mail"
                        className="me-2"
                        width={19}
                        height={14}
                      />
                      <Link
                        href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;tf=1&amp;to=sales@webcluesinfotech.com"
                        className="footer_link"
                        target="_blank"
                      >
                        sales@webcluesinfotech.com
                      </Link>
                    </li>
                    <li>
                      <Image
                        src="/assets/images/skype-small.svg"
                        alt="skype"
                        className="me-2"
                        width={19}
                        height={19}
                      />
                      <Link
                        href="skype:webcluesinfotech?chat"
                        className="footer_link"
                      >
                        webcluesinfotech
                      </Link>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="footer_bottom">
        <Container>
          <Row className="align-items-center">
            <Col lg={7}>
              <div className="d-block d-md-flex flex-row justify-content-center justify-content-lg-start mb-2 mb-lg-0">
                <ul className="copyright_link footer_bottom_link d-flex flex-row justify-content-center justify-content-lg-start py-2 mb-0">
                  <li className="mb-0">
                    Copyright &copy; {new Date().getFullYear()} WebClues
                    Infotech
                  </li>
                </ul>
                <ul className="footer_bottom_link d-flex flex-wrap flex-md-nowrap flex-row justify-content-center justify-content-lg-start py-2 mb-0">
                  <li className="mb-0">
                    <Link href="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li className="mb-0">
                    <Link href="/terms-and-conditions">
                      Terms &amp; Conditions
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
            <Col
              lg={5}
              className="d-flex justify-content-center justify-content-lg-end ftr_logo_img py-2 py-lg-0"
            >
              <Image
                src="/assets/images/footer-bottom-img1.png"
                className="ms-lg-auto"
                alt="img"
                width={334}
                height={30}
                style={{
                  maxWidth: '100%',
                  height: 'auto',
                }}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  )
}

export default Footer
